import { BaseEntity } from ".";
import { IGet_corporation_corporation_id_mining_observers_200_ok } from "../service/esiclient";
import moment from "moment";

export class CorporationMiningEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Corporation Mining Observer";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const props: Partial<IGet_corporation_corporation_id_mining_observers_200_ok> = this.props;
    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      let name = "Unknown";
      if (props.observer_id) {
        name = props.observer_id.toString();
      }
      if (props.last_updated) {
        const last_updated = moment(props.last_updated);
        entity.properties["last_updated"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: last_updated.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      entity.text = name;
      entity.properties["name"] = {
        type: Excel.CellValueType.string,
        basicValue: entity.text,
      };
    }
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
